import React from "react";
import { FaTrash } from "react-icons/fa";

import { ButtonRow, DeleteButton } from "../../Common/Components/FormComponents";
import { Section } from "../../Common/Styles/containers";
import { IClass } from "../../types/common";

interface ISettingsProps {
  class: IClass;
  deleteClass: () => void;
}

const Settings: React.FC<ISettingsProps> = props => {
  const confirmDelete = () => {
    if (confirm("Do you really want to delete this class?")) {
      props.deleteClass();
    }
  };
  return (
    <Section>
      <h2>Danger Zone</h2>
      <ButtonRow margin={1} width={14}>
        <DeleteButton onClick={confirmDelete}>
          <FaTrash /> Delete Class
        </DeleteButton>
      </ButtonRow>
    </Section>
  );
};

export default Settings;
